module.exports = __webpack_public_path__ + "static/media/icon-exit-door.da3a2efa.svg";